import { APP_TEXT } from "../const/app-text";
import DigitalSkillsCategorySelect from "./filters/digital-skills-category-select"
import DigitalSkillsResourceLocationSelect from "./filters/digital-skills-resource-location-select";
import DigitalSkillsResourceTypeSelect from "./filters/digital-skills-resource-type-select";
import {
    ButtonSize,
    SecondaryButton,
    ButtonVariant, TextInput
} from '@uni-of-exeter/digital.lib.react.ui.kit';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { LibraryFilterState, LocationOption, MediaTypeOption, SkillCategoryOption } from "../hooks/utils";

const pageText = APP_TEXT.pages.bookmarkedResources;

interface ResourceFilterProps {
    filters: LibraryFilterState,
    skillOptions: SkillCategoryOption[] | undefined,
    mediaTypeOptions: MediaTypeOption[] | undefined,
    locationOptions: LocationOption[] | undefined,
    hasActiveFilters: boolean,
    updateFilters: (filter: Partial<LibraryFilterState>) => void;
    resetFilters: () => void
}

export const ResourceFilter: React.FC<ResourceFilterProps> = ({
    filters, skillOptions, updateFilters, mediaTypeOptions, locationOptions,
    hasActiveFilters, resetFilters
}) => {
    return (
        <div className="tableHeader">
            <div className="tableFilters">
                <div className="filterContent">
                    <DigitalSkillsCategorySelect
                        value={filters.skillCategoryIds}
                        options={skillOptions ?? []}
                        onChange={(sc: string[]) => updateFilters({ skillCategoryIds: sc })}
                        label={pageText.filters.digitalSkillsCategory.label}
                    />
                </div>
                <div className="filterContent">
                    <DigitalSkillsResourceTypeSelect
                        value={filters.mediaTypes}
                        options={mediaTypeOptions ?? []}
                        onChange={(mt: string[]) => updateFilters({ mediaTypes: mt })}
                        label={pageText.filters.resourceType.label}
                    />
                </div>
                <div className="filterContent">
                    <DigitalSkillsResourceLocationSelect
                        value={filters.locations}
                        options={locationOptions ?? []}
                        onChange={(loc: string[]) => updateFilters({ locations: loc })}
                        label={pageText.filters.resourceLocation.label}
                    />
                </div>

                {hasActiveFilters && (
                    <div className="filterClearAll">
                        <SecondaryButton
                            aria-label={pageText.clearAll}
                            variant={ButtonVariant.Outline}
                            label={pageText.clearAll}
                            buttonSize={ButtonSize.Small}
                            onClick={resetFilters}
                        />
                    </div>
                )}
            </div>
            <div
                role="search"
                className="searchBox"
            >
                <TextInput
                    iconLeft={faSearch}
                    value={filters.searchQuery}
                    onChange={(s: string) => updateFilters({ searchQuery: s })}
                    placeholder={pageText.searchPlaceholder}
                />
            </div>
        </div>
    )
}